// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AudioProvider } from './contexts/AudioContext'; // This import is correct

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AudioProvider> {/* <--- WRAP App with AudioProvider START */}
      <App />
    </AudioProvider> {/* <--- WRAP App with AudioProvider END */}
  </React.StrictMode>
);

reportWebVitals();